// src/hooks/excel.js
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";

export const excel = ({ rows, showAlert, type, currentUser = {} }) => {
    try {
     
        if (!Array.isArray(rows) || rows.length === 0) {
            showAlert?.("excel: no rows to export");
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        const sheetName = typeof type === "string" && type.trim().length ? type : "Sheet1";
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName === "report" ? "Report" : "Eod Report");

        const keys = Object.keys(rows[0] || {});
        worksheet["!cols"] = keys.map(k => ({ wch: Math.max(15, String(k).length + 5) }));

        // 🟦 Style header row
        const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            const cell = worksheet[cellAddress];
            if (cell && cell.v !== undefined) {
                cell.s = {
                    fill: { fgColor: { rgb: "1E3A8A" } },
                    font: { bold: true, color: { rgb: "FFFFFF" } }, // white bold text
                    alignment: { wrapText: true },
                    border: {
                        top: { style: "thin", color: { rgb: "CCCCCC" } },
                        bottom: { style: "thin", color: { rgb: "CCCCCC" } },
                        left: { style: "thin", color: { rgb: "CCCCCC" } },
                        right: { style: "thin", color: { rgb: "CCCCCC" } },
                    },
                };
            }
        }

        // Save Excel file
        const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buffer], { type: "application/octet-stream" });

        const userPrefix = currentUser?.fullName ? `${currentUser.fullName} ` : "";
        const fileName = `${userPrefix}${sheetName.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]}.xlsx`;

        saveAs(blob, fileName);
    } catch (err) {
        console.error("excel util error:", err);
        throw err;
    }
};

export default excel;
